<template>
  <div :class="{ hidden: !visibleShow }" :hidden="!visibleShow">
    <slot name="visible" v-bind="{ visibleShow, invisibleShow, toggle }" />
  </div>
  <div :class="{ hidden: !invisibleShow }" :hidden="!invisibleShow">
    <slot name="invisible" v-bind="{ visibleShow, invisibleShow, toggle }" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleShow: true,
      invisibleShow: false
    }
  },
  methods: {
    toggle() {
      this.visibleShow = !this.visibleShow
      this.invisibleShow = !this.invisibleShow
    }
  }
}
</script>

<style lang="scss" scoped></style>
